/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
// import auth from '@/auth/authService'

// import firebase from 'firebase/app'
// import 'firebase/auth'

import {RoutesConfig} from './router/routes_config';
import {Authentication} from './router/Authentication'
import {Session} from './h5_src/framework/Session';


import {SuperDebug} from './utils/debug/Sdebug';
let debug_router = SuperDebug('router', true);


Vue.use(Router);


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: RoutesConfig

})

router.afterEach(() => {
  // Remove initial loading
  //   return;
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})


const executeNextRoute = function(from, to, next, param) {
  // BottomNavs.watchRoute(to, from);
  // debug_router('execute-next-param[%j] from[%s] to[%s]', param, from.fullPath, to.fullPath);
  if (param) {
      next(param);
  } else {
      next();
  }
};

router.beforeEach((to, from, next) => {

    // console.log(['before-each', from.fullPath, to.fullPath]);

  // 仅有 如下 3 个页面 不需要检查权限，其他所有路径都要检查
  let regex = new RegExp('^/public/.+', 'i');
  // console.log(to,from,next,regex)
  if (
      regex.test(to.path) ||
    to.path === "/pages/login" ||
    to.path === "/pages/error-404" ||
    to.path === "/pages/error-500" ) {

    next();
  } else {
    let access = Authentication.checkAccess(to);
    // debug_router('beforeEach-access', access);
    let prom = Session.onRouteChange(from, to, access);
    // debug_router('on-route-change-promise', prom);

    if (prom && prom.then) {
        // debug_router('using promise waiting userInfo response');
        prom.then(() => {
            // 这里应根据服务器返回的用户信息，更新 Session 或决定是否要跳转
            // 这次远程请求 userInfo 的方法内部已经设置了写入 本地 session （vuex 和 Local_Storage） 的逻辑
            // debug_router('promised-then next[%j]', access);
            executeNextRoute(from, to, next, access.param);
        });
    } else {
        // debug_router('next-route-directly');
        executeNextRoute(from, to, next, access.param);
    }

    // if (access.param) {
    //   next(access.param);
    // } else {
    //   next();
    // }

  }




  // firebase.auth().onAuthStateChanged(() => {

  //   // get firebase current user
  //   const firebaseCurrentUser = firebase.auth().currentUser

  //   // if (
  //   //     to.path === "/pages/login" ||
  //   //     to.path === "/pages/forgot-password" ||
  //   //     to.path === "/pages/error-404" ||
  //   //     to.path === "/pages/error-500" ||
  //   //     to.path === "/pages/register" ||
  //   //     to.path === "/callback" ||
  //   //     to.path === "/pages/comingsoon" ||
  //   //     (auth.isAuthenticated() || firebaseCurrentUser)
  //   // ) {
  //   //     return next();
  //   // }

  //   // If auth required, check login. If login fails redirect to login page
  //   if (to.meta.authRequired) {
  //     if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
  //       router.push({ path: '/pages/login', query: { to: to.path } })
  //     }
  //   }

  //   return next()
  //   // Specify the current path as the customState parameter, meaning it
  //   // will be returned to the application after auth
  //   // auth.login({ target: to.path });

  // })

    // return next()

})

export default router
